"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeType = void 0;
var SizeType;
(function (SizeType) {
    SizeType["LARGE"] = "l";
    SizeType["MEDIUM"] = "m";
})(SizeType = exports.SizeType || (exports.SizeType = {}));
